import { PersonSchedules } from 'types/interfaces';

export const EmployeeScheduleTemplate: PersonSchedules = {
  id: 0,
  scheduleId: 0,
  departmentId: 0,
  startDate: '',
  endDate: '',
  name: ''
};
